import { CustomerInfo } from "@/apps/shared/buyback/core/domain/service/DTO/customerInfo/customerInfo";
import { CustomerIdentification } from "@/apps/shared/buyback/core/domain/service/DTO/customerInfo/customerIdentification";

class CustomerInfoBuilder {
  buildFromParsedCustomerInfo(parsedCustomerInfo: any): CustomerInfo {
    return new CustomerInfo(
      parsedCustomerInfo.clientLastname,
      parsedCustomerInfo.clientFirstname,
      parsedCustomerInfo.clientEmail,
      parsedCustomerInfo.clientPhone,
      parsedCustomerInfo.clientStreet,
      parsedCustomerInfo.clientStreetMore,
      parsedCustomerInfo.clientZipCode,
      parsedCustomerInfo.clientCity,
      parsedCustomerInfo.clientCountry
    );
  }

  buildFromParsedCustomerIdentification(parsedCustomerIdentification: any): CustomerIdentification {
    return new CustomerIdentification(
      parsedCustomerIdentification.clientNationalIdentificationType,
      parsedCustomerIdentification.clientNationalIdentification,
      parsedCustomerIdentification.clientNationalIdentificationDeliveryDate,
      parsedCustomerIdentification.clientNationalIdentificationAutorityDelivery
    );
  }
}

export default new CustomerInfoBuilder();
